import {CrudService} from '../services/';

export const postScore = (data) => {

    return CrudService._post({
        url: 'scores',
        data
    });
};